var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"check-button-container",class:[_vm.value ? 'checked' : 'unChecked'],style:({ height: _vm.iconSize + 'px', width: _vm.iconSize + 'px', backgroundSize: _vm.iconSize + 'px' })},'div',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }